export default __webpack_public_path__ + "static/media/Help.d1f22762.svg";